module.exports = __webpack_public_path__ + "static/img/twjd-img8.452430b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-img8.png
// module id = 146
// module chunks = 0